export default __webpack_public_path__ + "static/media/dp.9b322a42.png";